<template>
  <div class="filter-wrapper">
    <div class="filter-options">
      <v-row>
        <v-col cols="12" md="8">
          <GradeClassStudentSelect disableStudentSelect @changed="gradeClassChange" />
        </v-col>
        <v-col cols="12" md="4" lg="4">
          <AutocompleteHeadTeacherCard
            v-model="selectedHeadTeacher"
            clearable
            clear-icon="mdi-close"
            outlined
            label="Giáo viên chủ nhiệm"
            dense
            deletable-chips
            hide-details
          />
        </v-col>
      </v-row>
    </div>
    <div class="filter-submit">
      <v-btn class="search-button" @click="onFilterChanged" outlined>
        Tìm kiếm
      </v-btn>
    </div>
  </div>
</template>

<script>
import GradeClassStudentSelect from '@/components/basic/filter/GradeClassStudentSelect.vue'
import AutocompleteHeadTeacherCard from '@/components/basic/input/AutocompleteHeadTeacherCard'
import { mapActions } from 'vuex'
import get from 'lodash-es/get'

export default {
  components: {
    GradeClassStudentSelect,
    AutocompleteHeadTeacherCard
  },
  data() {
    return {
      selectedGrade: {},
      selectedClass: {},
      selectedHeadTeacher: null
    }
  },
  methods: {
    ...mapActions('bankAccount', ['searchClasses']),
    gradeClassChange(data) {
      this.selectedGrade = { ...data.grade }
      this.selectedClass = { ...data.class }
    },
    onFilterChanged() {
      const params = {
        grade: get(this.selectedGrade, 'id'),
        id: get(this.selectedClass, 'id'),
        headTeachers: get(this.selectedHeadTeacher, 'id')
      }
      this.searchClasses(params)
    }
  }
}
</script>

<style lang="scss" scoped>
.filter-wrapper {
  display: flex;
  gap: 24px;

  @media screen and (max-width: 960px) {
    flex-direction: column;
  }
  .filter-options {
    flex: 1;
  }
  .filter-submit {
    margin-left: auto;
    align-self: flex-end;
  }
}
.text {
  width: 154px;
  height: 20px;

  /* Body regular */

  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  /* identical to box height, or 143% */
  /* icon, sub */

  color: #797979;
}

.text-name {
  /* Toàn trường */
  width: 290px;
  height: 24px;

  /* H4 */

  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  /* identical to box height, or 133% */
  color: #000000;
}
div.buttonSearch {
  width: 106px;
}
div.inputSearch {
  width: calc(100% - 120px - 12px);
}
@media screen and (max-width: 960px) {
  div.buttonSearch {
    width: 110px;
    padding-top: 24px;
    margin-left: 0px !important;
  }
  div.inputSearch {
    width: 100%;
  }
}
</style>
